module.exports = __webpack_public_path__ + "img/image-visit-us-01-academy-template.1e9f5433.jpg";